import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';

import Toggle from 'react-toggle';

import { Modal } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';

class PaymentDistanceEditModal extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      schedule_name_id: '',
      daily_currency: '',
      schedule_name_selected: 1,
      ignores_debts: 1,
      schedule_name: '',
      aircraft_model: '',
      staff: '',
      daily_value: 1,
      distance: 1,
      payment_days: [],
      payment_editions: [],
      bonus: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.editPayment = this.editPayment.bind(this);
    this.addDay = this.addDay.bind(this);
    this.deleteDay = this.deleteDay.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleChangeDailyValue (event, name) {
    var change = {};
    change[name] = event;

    this.setState(change);
    this.handleChangeDailyTotal(event, this.state.distance);
  }

  handleChangeDaily (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(event.target.value, this.state.distance);
  }
  handleChangeDailyPaid (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(this.state.daily_value, event.target.value);
  }

  handleChangeDailyTotal (daily_value, distance) {
    var distance = distance;
    if (isNaN(distance)) {
      distance = 0;
    }
    var total = distance * daily_value;

    this.setState({daily_total: total.toFixed(2)});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_payment_daily.id !== 'undefined') {
        this.setState({
          payment_days: newProps.data_payment_daily.payment_days,
          payment_editions: newProps.data_payment_daily.payment_editions,
          schedule_name: newProps.data_payment_daily.schedule_name,
          aircraft_model: newProps.data_payment_daily.aircraft_model,
          staff: newProps.data_payment_daily.staff,
          date_start: newProps.data_payment_daily.date_start_str,
          date_finish: newProps.data_payment_daily.date_finish_str,
          daily_value: newProps.data_payment_daily.daily_value,
          distance: newProps.data_payment_daily.distance_flt,
          daily_total: newProps.data_payment_daily.daily_total,
          daily_currency: newProps.data_payment_daily.daily_currency,
          revision: newProps.data_payment_daily.revision,
          certification_supplier: newProps.data_payment_daily.certification_supplier,
          bonus: newProps.data_payment_daily.bonus,
          id: newProps.data_payment_daily.id,
          ignores_debts: newProps.data_payment_daily.ignores_debts,
          justification: newProps.data_payment_daily.justification,
          observation: newProps.data_payment_daily.observation,
        });
      }
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  // Fetch salvando a adição de diária
  deleteDay(id) {
    if (window.confirm(this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.deletarEsseDia)) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/pagamento/dia/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({ payment_days: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch deletando a diária
  addDay(event) {
    event.preventDefault();
    var datasave = {
      date: this.state.date,
      coefficient: this.state.coefficient,
      payment_id: this.state.id,
    };
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/dia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({ payment_days: responseJson.data });
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  editPayment(event) {
    event.preventDefault();
    var datasave = {
      payment_type: 'daily',
      justification: this.state.justification,
      ignores_debts: this.state.ignores_debts,
      observation: this.state.observation,
      daily_value: this.state.daily_value,
      distance: this.state.distance,
      daily_total: this.state.daily_total,
      bonus: this.state.bonus,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({ modal: false });
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tituloEditarPagamento}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.editPayment}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.Escala}:</label>
                    <input value={this.state.schedule_name + ' - ' + this.state.aircraft_model} disabled="disabled" name="schedule_name" className="form-control" onChange={this.handleChange.bind(this, 'schedule_name')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.CodigoDoTreinamento}:</label>
                    <input type="text" name="revision" disabled="disabled" className="form-control" placeholder="" value={this.state.revision} onChange={this.handleChange.bind(this, 'revision')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.Local}:</label>
                    <input value={this.state.certification_supplier} disabled="disabled" name="certification_supplier" className="form-control" onChange={this.handleChange.bind(this, 'certification_supplier')} placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.placeholder.Local} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.Tripulante}:</label>
                    <input value={this.state.staff} disabled="disabled" name="staff" className="form-control" onChange={this.handleChange.bind(this, 'staff')} placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.placeholder.Tripulante} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.Valor}:</label>
                    <input value={this.state.daily_value} disabled="disabled" name="daily_value" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_value')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.DistanciaKm}:</label>
                    <input type="number" value={this.state.distance} name="distance" className="form-control" onChange={this.handleChangeDailyPaid.bind(this, 'distance')} placeholder="" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.Moeda}:</label>
                    <input value={this.state.daily_currency} disabled="disabled" name="daily_currency" className="form-control" onChange={this.handleChange.bind(this, 'daily_currency')} placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.placeholder.Moeda} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.Total}:</label>
                    <input value={this.state.daily_total} disabled="disabled" name="daily_total" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_total')} placeholder="" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.Observacao}:</label>
                    <input value={this.state.observation} name="observation" className="form-control" onChange={this.handleChange.bind(this, 'observation')} placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.placeholder.Observacao} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.IgnorarSaldoDevedor}?</label>
                    <br/>
                    <Toggle
                      defaultChecked={this.state.ignores_debts}
                      checked={this.state.ignores_debts}
                      aria-label='No label tag'
                      name="ignores_debts"
                      onChange={this.handleToggleChange.bind(this, 'ignores_debts')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.JustificativaDeEdicao}:</label>
                    <input value={this.state.justification} required name="justification" className="form-control" onChange={this.handleChange.bind(this, 'justification')} placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.placeholder.JustifiqueAEdicao} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.formularioEditarPagamento.botaoSalvarPagamento}</button>
                </div>
              </div>
            </form>
            <hr/>
            <h3>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tituloLogDeEdicoesDoPagamento}</h3>
            <hr/>
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.Id}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.QuantidadeAnterior}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.QuantidadeEditada}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.ValorUnitarioAnterior}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.ValorUnitarioEditado}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.ValorTotalAnterior}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.ValorTotalEditado}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.StatusdeSaldoDevedorAnterior}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.StatusDeSaldoDevedorEditado}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.UsuArio}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.Justificativa}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeDeslocamento.tabelaLogDeEdicoesDoPagamento.Data}</th>
                </tr>
              </thead>
              <tbody id="schedule_name-certification-staffs">
                {Object.keys(self.state.payment_editions).map(function(k) {
                  return (
                    <tr>
                      <td className="text-center">{self.state.payment_editions[k].id}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_daily_paid}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_daily_paid}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_daily_value}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_daily_value}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_daily_total}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_daily_total}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_ignores_debts}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_ignores_debts}</td>
                      <td className="text-center">{self.state.payment_editions[k].user}</td>
                      <td className="text-center">{self.state.payment_editions[k].justification}</td>
                      <td className="text-center">{self.state.payment_editions[k].date_str}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PaymentDistanceEditModal;



// WEBPACK FOOTER //
// ./src/Components/SchedulePayments/PaymentDistanceEditModal.js